
import HttpClienteApiKey from '../../services/HttpClientApiKey';
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultVersionResponse, HttpResponse, LoginParams, LoginResponse, VersionResponse } from '../../interfaces/auth/AuthInterface';

export const Login = ( params : LoginParams ) => {

    return new Promise<LoginResponse>( ( resolve, eject ) => {

        HttpClienteApiKey.post('/Api/Auth/Login', params)
        .then( ( { data } : { data : LoginResponse }) => {
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {    
            resolve( { success: false, message: error.message } );
        });

    });

}

export const Logout = () => {

    return new Promise<HttpResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Auth/Logout/', null, token)
            .then( ({ data } : { data : HttpResponse} ) => {               
                resolve( data );                
            })
            .catch( (error: AxiosError) => {
                
                const data: HttpResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}

export const ValidarToken = () => {

    return new Promise<HttpResponse>( ( resolve, eject ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Auth/ValidarToken/', null, token)
            .then( ({ data } : { data : HttpResponse} ) => {               
                resolve( data );                
            })
            .catch( (error: AxiosError) => {
                
                const data: HttpResponse = {
                    success: false,
                    message: error.message,
                };
    
                resolve( data );
            });
        }

    });

}

export const ObtenerVersion = () => {

    return new Promise<VersionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Auth/ObtenerVersion/', token)
            .then( ({ data } : { data : VersionResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultVersionResponse, message: error.message } );
            });
        }

    });

}